import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import GoToTop from './GoToTop';
import PromoBanner from './PromoBanner';
import CompareTray from './CompareTray';

const PublicLayout = ({ children }) => {
  return (
    <div className='flex flex-col min-h-screen'>
      <PromoBanner />
      <Header />
      <main className='flex-1'>
        {children || <Outlet />}
      </main>
      <Footer />
      <GoToTop />
      <CompareTray />
    </div>
  );
};

export default PublicLayout;
